module.exports = __webpack_public_path__ + "img/jp-hannel-banner.c92bdb50.png";